define(
  'app/views/search_results_view',[
    'app/setup', 'app/collections/search_products', 'app/models/search_product',
    'app/views/search_view','app/views/lazy_view'
  ],
  function(takhfifan, searchProducts, searchProduct, searchView, lazyView) {

  takhfifan.SearchResultsView = takhfifan.SearchView.extend({
    events: {
      'click #tkhSearchOrdersList li' : 'updateSearchCollection',
      'click #tkhSearchLimitsList li' : 'updateLimit',
      'click #tkhSearchButton' : 'updateQuery',
      //'mouseleave .noUi-handle': 'updatePriceRange',
      //'click .noUi-target': 'updatePriceRange',
      'click .price-button input': 'updatePriceRange',
      "change #tkhSearchCategories li div.checkbox input" : 'updateCategory',
      "change #tkhSearchBrands li div.checkbox input" : 'updateBrand',
      'click #tkhPaginationList li' : 'updatePage',
      'keyup #search-field': 'updateQueryWithTimer',
      'click .sort-control ul li' : 'activeClass'
    },

    template: ( $('#search-list-template').length > 0 ) ?
      _.template( $('#search-list-template').html() ) : '',

    render: function() {
      this.$(".tkh-search-deal-Wrapper").html(
        this.template({
          products:this.collection.toJSON(),
          pagination: this.collection.pagination
        })
      );
/*
      var paginationTemplate = _.template($('#search-list-pagination').html());

      var paginationContent = paginationTemplate(
        {pagination: this.collection.pagination}
      );

      this.$(".tkh-search-pagination").html(paginationContent);
*/
      this.$("#tkhSearchToolbarText").html(this.collection.q);

      this.$("#tkhSearchToolbarNumOfResults").html(
        this.collection.pagination.totalNumber
      );

      this.$("#tkhSearchToolbarFirstNum").html(
        this.collection.pagination.firstNum
      );

      this.$("#tkhSearchToolbarLastNum").html(
        this.collection.pagination.lastNum
      );

//      this.$(".discount-progress").each(function(){
//        var $circle = $('.fill', this), $percent = $('#percent', this), r = $circle.attr('r'), c = Math.PI*(r*2);
//        var val = $(this).attr('data-percent');
//        if ( isNaN(val) ) {
//          val = 100;
//        } else {
//          if (val < 0) { val = 0;}
//          if (val > 100) { val = 100;}
//          var pct = (-(0+val)/100)*c;
//          $circle.css({ strokeDashoffset: pct });
//        }
//      });
    },

    initialize: function(options) {
      this.options = options;
      var _this = this;
      this.queryTimer = [];
      var initData =  this.$(".tkh-search-deal-Wrapper").first().data('initialize');
      var hasValidInitData = false;
      var initModels;

      if (typeof initData != 'undefined') {
        initModels = initData.models;
        if (initModels && initModels.length) {
          hasValidInitData = true;
        }
      }        

      if (hasValidInitData) {
          this.collection = new takhfifan.SearchProducts(initModels);
      } else {
        this.collection = new takhfifan.SearchProducts();
      }

      this.collection.q = this.$("#search-field").val();
      var city_id = this.$("#search-city-field").val(); 

      if(city_id != null && city_id!='') {
        this.collection.cityId = this.$("#search-city-field").val();
      }

      // default order
      this.collection.order = 'deal_start_date';

      // default sort order
      this.collection.sortOrder = 'asc';

      if(hasValidInitData && initData.pagination) {
        this.collection.pagination = initData.pagination;
      }

      $("#tkhSearchLimitsList li").each(function() {
        if($(this).data('selected')) {
          _this.collection.limit = $(this).data('key');
        }
      });
      //this.collection.bind('reset', this.render, this);
      this.collection.bind("change reset add remove", this.render, this);
      this.currentUpperPrice=_this.$(".tkhUpperPriceValue").val();
      this.currentLowerPrice=_this.$(".tkhLowerPriceValue").val();
      this.collectionAbruptFetch=true;
      takhfifan.eventHub.on('window:scroll', this.load, this);
    },

    load: function(force) {
      var _this = this;
      this.$('.lastdeal').each(function(index){
        if (_this.isOnScreen($(this)) && !$(this).hasClass('disabledTrigger')) {
          _this.increasePage();
           $(this).addClass('disabledTrigger');
        }
      });
    },

    updateSearchCollection: function(ev) {
      $('.wrapper').before('<div class="search-loading"></div>');
      var key = $(ev.currentTarget).data('key');
      this.collection.order = key;
      this.collection.sortOrder = $(ev.currentTarget).data('sort');
      this.collection.pageNum = undefined;
      this.collection.fetch({reset: true}).always(function(){ $('.search-loading').remove(); });
    },

    updateLimit: function(ev) {
      this.collection.limit = $(ev.currentTarget).data('key');
      this.collection.pageNum = undefined;
      this.collection.fetch({reset: true});
    },

    increasePage: function() {
      if(_.isUndefined(this.collection.pageNum)) {
        this.collection.pageNum = 1;
      }
      if(this.collection.pageNum + 1 <= this.collection.pagination.lastPage) {
        this.collection.pageNum = this.collection.pageNum + 1;
        this.collection.fetch({remove:false});
      }
    },

    activeClass: function (ev) {
        $('.sort-control ul li').removeClass('active');
        $(ev.currentTarget).toggleClass('active');
    }
  });
});

